module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row well well-sm no-shadow animated fadeInDownOutUp",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-3 col-lg-2"
  }, [_vm._v("Adicionar documento em:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('label', {
    staticClass: "new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoVinculo),
      expression: "tipoVinculo"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "type": "radio",
      "name": "vinculo",
      "value": "Projeto"
    },
    domProps: {
      "checked": _vm._q(_vm.tipoVinculo, "Projeto")
    },
    on: {
      "change": [function($event) {
        _vm.tipoVinculo = "Projeto"
      }, _vm.vinculoSelecionado]
    }
  }), _vm._v(" Projeto\n              "), _c('span', {
    staticClass: "espacamento_botoes"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoVinculo),
      expression: "tipoVinculo"
    }],
    staticClass: "ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "type": "radio",
      "name": "vinculo",
      "value": "Entidade"
    },
    domProps: {
      "checked": _vm._q(_vm.tipoVinculo, "Entidade")
    },
    on: {
      "change": [function($event) {
        _vm.tipoVinculo = "Entidade"
      }, _vm.vinculoSelecionado]
    }
  }), _vm._v(" Entidade\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('vinculo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3 col-lg-2",
    attrs: {
      "for": "vinculo"
    }
  }, [_vm._v(_vm._s(this.tipoVinculo === null ? 'Escolha acima onde adicionará o documento' : this.tipoVinculo) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.idVinculo),
      expression: "idVinculo"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "name": "vinculo",
      "id": "vinculo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.idVinculo = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._l((_vm.listaVinculos), function(item) {
    return (_vm.tipoVinculo === 'Projeto') ? _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.ds_codigo_projeto_erp) + " - " + _vm._s(item.ds_nome))]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.listaVinculos), function(item) {
    return (_vm.tipoVinculo === 'Entidade') ? _c('option', {
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.ds_nome))]) : _vm._e()
  })], 2)]), _vm._v(" "), (_vm.errors.first('vinculo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('vinculo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('tipo de documento')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3 col-lg-2",
    attrs: {
      "for": "tipo de documento"
    }
  }, [_vm._v("Tipo de documento:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.documento.tipo_documento),
      expression: "documento.tipo_documento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control ng-pristine ng-untouched ng-valid ng-not-empty",
    attrs: {
      "name": "tipo de documento",
      "id": "tipo de documento"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.documento, "tipo_documento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.documentos), function(documento) {
    return _c('option', {
      domProps: {
        "value": documento
      }
    }, [_vm._v(_vm._s(documento.ds_tipo))])
  }), 0)]), _vm._v(" "), (_vm.errors.first('tipo de documento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de documento')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('arquivo')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3 col-lg-2",
    attrs: {
      "for": "file"
    }
  }, [_vm._v("Arquivo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        size: _vm.tamanhoPermitido,
        mimes: _vm.tiposPermitidos
      }),
      expression: "{required: true, size: tamanhoPermitido, mimes: tiposPermitidos}"
    }],
    ref: "file",
    attrs: {
      "type": "file",
      "name": "arquivo",
      "id": "file"
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })])]), _vm._v(" "), (_vm.errors.first('arquivo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('arquivo')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.first('Vigencia')
    },
    attrs: {
      "ng-class": "{ 'has-error' : frmAddFile.$submitted && frmAddFile.expirationDate.$error.date || frmAddFile.expirationDate.$error.validateChange }"
    }
  }, [_c('label', {
    staticClass: "control-label col-md-3 col-lg-2",
    attrs: {
      "for": "expirationDate"
    }
  }, [_vm._v("Vigência:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-16"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dt_data_vigencia),
      expression: "dt_data_vigencia"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('validdate'),
      expression: "'validdate'"
    }],
    ref: "Vigencia",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "Vigencia",
      "data-vv-as": "Vigencia",
      "masked": _vm.masked
    },
    domProps: {
      "value": (_vm.dt_data_vigencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dt_data_vigencia = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Vigencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('Vigencia')))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "col-md-9 col-lg-10 col-md-offset-3 col-lg-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-confirm btn-flat",
    attrs: {
      "type": "button",
      "id": "cmpt-upload-add"
    },
    on: {
      "click": _vm.adicionaDocumento
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Ok ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-back btn-flat",
    attrs: {
      "type": "button",
      "id": "cmpt-upload-cancel"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43be472e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/uploadDocumento.vue
// module id = 1933
// module chunks = 1